import { getDefaultMessage } from '@/plugins/vee-validate/messages/default';
import { CounterSMS } from '@/plugins/sms-counter';

export const smsCountMessage = (field, values) => {
  const { encoding, per_message } = CounterSMS.count(values._value_);
  const { max_sms_count } = values;
  const max_symbol_count = max_sms_count * per_message;

  return getDefaultMessage(field, { ...values, encoding, max_symbol_count });
};
